import OliverText from "@builder/components/general/OliverText";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ActionType } from "@common/build/types";
import { useEffect, useState } from "react";
import SimpleCheckbox from "@builder/components/general/SimpleCheckbox";

const TerminalAction = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const [paymentDetails, setPaymentDetails] = useState<any>(
        actionStep?.action?.data || {
            addedFee: { value: "", type: "$" },
            addedDiscount: { value: "", type: "$" },
            tips: {
                request: false,
                customTip1: { label: "", amount: { value: "", type: "%" } },
                customTip2: { label: "", amount: { value: "", type: "%" } },
                customTip3: { label: "", amount: { value: "", type: "%" } },
                allowCustomTips: false,
                allowNoTips: false
            },
            terminal: "bluetooth"
        }
    );

    const dispatch = useAppDispatch();

    const updateNodeProperty = (propertyPath: string[], value: any) => {
        setPaymentDetails((prev: any) => {
            const newDetails = { ...prev };

            let current = newDetails;
            for (let i = 0; i < propertyPath.length - 1; i++) {
                current[propertyPath[i]] = { ...current[propertyPath[i]] };
                current = current[propertyPath[i]];
            }

            current[propertyPath[propertyPath.length - 1]] = value;

            return newDetails;
        });
    };

    // const handleAmount = (value: string, key: "addedFee" | "addedDiscount") => {
    //     updateNodeProperty([key, "value"], value);
    // };

    // const handleToggle = (key: "addedFee" | "addedDiscount") => {
    //     setPaymentDetails((prevDetails: any) => {
    //         const updatedDetails = { ...prevDetails };
    //         const updatedKey = { ...updatedDetails[key] };

    //         updatedKey.type = updatedKey.type === "$" ? "%" : "$";

    //         updatedDetails[key] = updatedKey;

    //         return updatedDetails;
    //     });
    // };

    const handleTerminalChange = (type: "cloud" | "bluetooth") => {
        updateNodeProperty(["terminal"], type);
    };

    useEffect(() => {
        const action = {
            type: ActionType.TERMINAL,
            data: paymentDetails
        };

        const updatedStep = { ...actionStep };
        updatedStep.action = { ...action };

        if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
            dispatch(updateStepperActions({ id: id as string, item: updatedStep as ActionEditorItem }));
        }
    }, [paymentDetails, actionStep, dispatch, id]);

    return (
        <div className="function-add-cart-note-wrapper">
            <div className="function-add-cart-note">
                <div className="function-add-cart-note-wrapper">
                    <OliverText text="Connection type" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />

                    <div className="function-checkbox-wrapper" onClick={() => handleTerminalChange("bluetooth")}>
                        <div className="function-checkbox-label-wrapper">
                            <OliverText text="Bluetooth" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                            <OliverText
                                text="This will use the bluetooth connection"
                                size="xs"
                                weight="light"
                                translatePrefix="popup.actionBuilder."
                            />
                        </div>
                        <SimpleCheckbox callback={() => {}} checked={paymentDetails.terminal === "bluetooth"} label="" value="" custom={false} />
                    </div>
                    <div className="function-checkbox-wrapper" onClick={() => handleTerminalChange("cloud")}>
                        <div className="function-checkbox-label-wrapper">
                            <OliverText text="Cloud" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                            <OliverText text="This will use cloud connection" size="xs" weight="light" translatePrefix="popup.actionBuilder." />
                        </div>
                        <SimpleCheckbox callback={() => {}} checked={paymentDetails.terminal === "cloud"} label="" value="" custom={false} />
                    </div>

                    {/* <TextInput
                        title="Add fee"
                        callback={value => handleAmount(value, "addedFee")}
                        value={paymentDetails.addedFee?.value || ""}
                        className="actions-tab-input"
                        placeholder="Amount"
                        icon={{
                            src: ["./dollar-sign.svg", "./percentage-sign.svg"],
                            callback: (event: React.MouseEvent) => {
                                event.preventDefault();
                                handleToggle("addedFee");
                            }
                        }}
                        isPercent={paymentDetails.addedFee?.type === "%"}
                    />
                    <TextInput
                        title="Add discount"
                        callback={value => handleAmount(value, "addedDiscount")}
                        value={paymentDetails.addedDiscount?.value || ""}
                        className="actions-tab-input"
                        placeholder="Amount"
                        icon={{
                            src: ["./dollar-sign.svg", "./percentage-sign.svg"],
                            callback: (event: React.MouseEvent) => {
                                event.preventDefault();
                                handleToggle("addedDiscount");
                            }
                        }}
                        isPercent={paymentDetails.addedDiscount?.type === "%"}
                    /> */}
                </div>
            </div>
        </div>
    );
};

export default TerminalAction;
